export const UnknownProfileIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 17C19.3137 17 22 14.3137 22 11C22 7.68629 19.3137 5 16 5C12.6863 5 10 7.68629 10 11C10 14.3137 12.6863 17 16 17ZM16 18C10.2138 18 5.4674 22.4004 5 28H27C26.5326 22.4004 21.7862 18 16 18Z"
      fill="#57606A"
    />
  </svg>
);
